export default {
  addNew: 'สั่งตรวจรายใหม่',
  labRequestHeader: 'ลงทะเบียนผู้ป่วย/สั่งตรวจ',
  labRequest: 'การสั่งตรวจทางห้องปฏิบัติการ',
  lablaboratoryName: 'ชื่อห้องปฏิบัติการ',
  dateCreated: 'วันที่สั่งตรวจ',
  patientName: 'ชื่อคนไข้',
  patientId: 'รหัสผู้ป่วย',
  patientFullname: 'ชื่อ-นามสกุล',
  status: 'สถานะ',
  mainMenu: 'กลับหน้าหลัก',
  addEditHeader1: 'ข้อมูลผู้ป่วย (กรุณากรอกข้อมูลให้ครบถ้วน เพื่อประโยชน์ของผู้ป่วย)',
  addEditHeader2: '(กรุณากรอกข้อมูลให้ครบถ้วน',
  addEditHeader3: 'เพื่อประโยชน์ของคนไข้)',
  patientEditButton: 'แก้ไขข้อมูลคนไข้',
  saveEditPatientbutton: 'บันทึกข้อมูลคนไข้',
  HN: 'HN',
  prefix: 'คำนำหน้า',
  prefixRequire: 'คำนำหน้า*',
  firstName: 'ชื่อจริง',
  middleName: 'ชื่อกลาง',
  lastName: 'นามสกุล',
  brithDay: 'วันเกิด',
  brithDayRequire: 'วันเกิด*',
  age: 'อายุ',
  receiveData: 'วันที่เก็บสิ่งส่งตรวจ',
  requestBy: 'แพทย์ผู้สั่งตรวจ',
  sex: 'เพศ',
  sexRequire: 'เพศ*',
  brithdayOrAge: 'วันเกิดหรืออายุ',
  orderitemHeader: 'รายการสั่งตรวจ',
  lablaboratory: 'ห้องปฏิบัติการ',
  search: 'ค้นหา',
  orderItem: 'รายการสั่งตรวจ',
  orderItemSelected: 'รายการสั่งที่เลือก',
  save: 'บันทึก',
  close: 'ปิด',
  cancel: 'ยกเลิก',
  statusObj: {
    OP: 'ขอตรวจ',
    COLLECTION: 'รอรับสิ่งส่งตรวจ',
    RECEIVEDALL: 'รับสิ่งส่งตรวจเเล้ว',
    FIRSTAPPROVE: 'รายงานผล',
    LASTAPPROVE: 'อนุมัติผล',
    CA: 'ยกเลิกส่งตรวจ',
    labApprove: 'ส่งผลแล้ว',
    labNotApprove: 'รอส่งผล'
  },
  labNumber: 'เลขที่สั่งตรวจ',
  turnaroundTime: 'ระยะเวลารอผล(วัน)',
  saveCreateLabOreder: 'สั่งตรวจ',
  remark: 'หมายเหตุ',
  remarkForm: 'แบบฟอร์ม',
  packageNo: 'Package No',
  sendDate: 'วั่งที่ส่งตรวจ',
  errorNolab: 'กรุณาสร้างคำสั่งตรวจก่อน',
  collectDate: 'วันที่เก็บสิ่งส่งตรวจ',
  viewItem: 'รายละเอียดรายการสั่งตรวจ',
  viewOrderId: 'รหัสการสั่งตรวจ',
  viewOrderDesc: 'ชื่อการสั่งตรวจ',
  cancelPackage: 'ยกเลิกแพ็คเกจ',
  sendPackage: 'ส่งตรวจ(รวมแพ็กเกจ)',
  payment: 'ประเภทการชำระเงิน',
  hln: 'Hospital lab no.',
  paymentStatus: 'สถานะการชำระเงิน',
  paymentType: 'ข้อมูลการชำระเงิน',
  cancelLab: 'ยกเลิกสั่งตรวจ',
  paymentPage: 'การชำระเงิน',
  orderID: 'รหัส',
  orderName: 'ชื่อรายการตรวจ',
  labStatus: 'สถานะการสั่งตรวจ',
  labApproveStatus: 'สถานะการส่งผล',
  refDoc: 'เอกสารอ้างอิง',
  serviceChannel: 'ช่องทางการให้บริการ',
  price: 'ราคา (บาท)',
  specimenType: 'สิ่งส่งตรวจ',
  selectProbes: 'Select Probes',
  diagnosis: 'Diagnosis',
  diagnosisDesc: 'โรค/การวินิจฉัย',
  errorPrice: 'กรุณาติดต่อเจ้าหหน้าที่เพื่อยืนยันราคา เนื่องจากรายการนี้อยู่นอกช่วงเวลาที่กำหนด',
  isGetBack: 'ขอคืนตัวอย่าง',
  releasedDate: 'วันที่ส่งตรวจ',
  receivedDate: 'วันที่รับสิ่งส่งตรวจ',
  isUrgent: 'ขอผลด่วน',
  reportedDate: 'วันที่รายงานผล',
  volumnUrine: 'Volumn Urine',
  addOrderItem: 'เพิ่มรายการสั่งตรวจ',
  deleteOrderItem: 'ลบรายการสั่งตรวจ',
  specimenID: 'เลขที่สิ่งส่งตรวจ',
  requireCollectDateError: 'ไม่สามารถปิดหน้าต่างได้ เนื่องจากมีรายการที่ยังไม่ได้แก้ไขวันที่เก็บสิ่งส่งตรวจ',
  editCollectionDate: 'แก้ไขวันที่เก็บสิ่งส่งตรวจ',
  requestReport: 'ใบสั่งตรวจ',
  packageReport: 'ใบแพคเกจ',
  clearData: 'เคลียร์ข้อมูล',
  searchData: 'ค้นหาข้อมูล',
  receiptCreate: 'ออกใบเสร็จแล้ว',
  receiptSent: 'ส่งใบเสร็จแล้ว',
  note: 'หมายเหตุ',
  submit: 'ยืนยัน',
  searchPatient: 'ค้นหาข้อมูลผู้ป่วย',
  add: 'เพิ่ม',
  request: 'คำสั่งตรวจ',
  editPatientInfo: 'แก้ไขข้อมูลคนไข้',
  patientInfo: 'ข้อมูลคนไข้',
  searchName: 'ค้นหาชื่อ',
  searchLastName: 'ค้นหานามสกุล',
  searchHN: 'ค้นหา HN',
  totalPrice: 'ราคารวมทั้งหมด',
  enterReceiveDate: 'กรุณาระบุวันที่เก็บสิ่งส่งตรวจ',
  comment: 'หมายเหตุ',
  saveSucess: 'บันทึกรายการตรวจเรียบร้อย',
  cannotEditOldPatient: 'ไม่สามารถแก้ไขข้อมูลคนไข้เก่าได้',
  confirmDeleteSelected: 'ลบรายการสั่งตรวจที่เลือก ?',
  errorDuplicateItem: 'ไม่สามารถเลือกรายการที่มีอยู่เเล้วได้',
  createOrderSuccess: 'สร้างคำสั่งตรวจใหม่สำเร็จ',
  aOrderItem: 'รายการสั่งตรวจ',
  beforeAddOrderItem: ' ให้ครบถ้วนก่อนเพิ่มรายการสั่งตรวจ',
  prefixSexMismatch: 'เเละเลือกคำนำหน้ากับเพศให้ตรงกัน',
  pleaseFill: 'กรุณากรอก',
  errorCreateOrderIncompleteData: 'กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน ได้แก่ ชื่อจริง, วันเกิด, เพศ และรายการตรวจ',
  errorCreatePackageBeforeSend: 'กรุณาสร้างคำสั่งตรวจก่อน',
  printRequestError: 'กรุณาทำการส่งตรวจก่อน',
  confirmCloseWithoutSave: 'ต้องการออกจากหน้าสั่งตรวจโดยไม่บันทึกหรือไม่?',
  pleaseSelectItemToSend: 'กรุณาเลือกรายการที่ต้องการส่งตรวจ',
  pleaseSelectItemToCancelSend: 'กรุณาเลือกรายการที่ต้องการยกเลิกส่งตรวจ',
  pleaseSelectItemToCancel: 'กรุณาเลือกรายการที่ต้องการยกเลิก',
  pleaseSelectItemToPrint: 'กรุณาเลือกรายการที่ต้องการพิมพ์ใบสั่งตรวจ',
  pleaseSelectItemToPrintPackage: 'กรุณาเลือกรายการที่ต้องการพิมพ์ใบแพคเกจ',
  confirmSendRequest: 'ต้องการสร้างแพ๊กเกจส่งตรวจ ?',
  confirmCancelSendRequest: 'ต้องการยกเลิกส่งตรวจ ?',
  sendRequestSuccess: 'ส่งตรวจเรียบร้อยเเล้ว กรุณาชำระเงิน',
  confirmCancelLabRequest: 'ต้องการยกเลิกส่งตรวจ ?',
  confirmPrintRequest: 'ต้องการพิมพ์ใบสั่งตรวจ ?',
  printPackageError: 'กรุณาทำการสร้างแพคเกจก่อน',
  confirmPrintPackage: 'ต้องการพิมพ์ใบแพคเกจ ?',
  errorSendRequestDateSendNotNull: 'Order ที่ทำการส่งตรวจแล้ว ไม่สามารถส่งซ้ำได้ กรุณายกเลิกการส่งตรวจเก่าก่อน',
  errorCannotCancelSendRequestReceived: 'ไม่สามารถยกเลิกรายการตรวจได้ เนื่องจากเคยมีการรับ specimen แล้ว.',
  errorCannotCancelSendRequest: 'ไม่สามารถยกเลิกการส่งตรวจได้.',
  cancelSendRequestSuccess: 'ยกเลิกส่งตรวจเรียบร้อยเเล้ว',
  errorCannotCancelNotSendRequest: 'Order ที่ยังไม่ทำการส่งตรวจ ไม่สามารถยกเลิกการส่งตรวจได้.',
  errorCreatePackageBeforeCancel: 'กรุณาสร้างคำส่งตรวจก่อน',
  errorCannotCancelLabRequestPackageNotNull: 'Order ที่ยังมีแพ็คเกจอยู่ไม่สามารถยกเลิกได้.',
  errorCannotCancelLabRequestAlreadyCancelled: 'ไม่สามารถยกเลิก Order ที่ยกเลิกเเล้วได้.',
  createOrderFailed: 'สร้างคำสั่งตรวจใหม่ไม่สำเร็จ',
  errorFindPatient: 'กรุณาค้นหาด้วยชื่อ หรือนามสกุล หรือ HN',
  cannotCreateOrder: 'ไม่สามารถสร้างคำสั่งตรวจใหม่ได้',
  editPatient: 'แก้ไขข้อมูลคนไข้',
  editPatientFailed: 'แก้ไขข้อมูลคนไข้ไม่สำเร็จ',
  errorPayment: 'ไม่มีข้อมูลประเภทการชำระเงิน กรุณาติดต่อเจ้าหน้าที่',
  savePatientSuccess: 'บันทึกข้อมูลเรียบร้อย',
  searchCustomerName: 'ค้นหาชื่อลูกค้า',
  customer: 'ลูกค้า',
  PleaseEnterCustomerName: 'กรุณากรอกชื่อลูกค้าก่อนค้นหา',
  PleaseEnterPrefixFirstNameAndLastName: 'รุณากรอก Prefix, First Name และ Last Name ก่อน',
  patientRights: 'สิทธิ์ของผู้ป่วย*',
  cid: 'เลขประจำตัวประชาชน',
  CustomerType: 'ประเภทลูกค้า',
  phoneNumber: 'เบอร์โทรศัพท์',
  TaxIDNumber: 'เลขประจำตัวผู้เสียภาษี',
  emailAddress: 'E-mail Address',
  CustomerName: 'ชื่อลูกค้า',
  address: 'ที่อยู่',
  addressOptional: 'ที่อยู่ 2 (ไม่บังคับ)',
  city: 'เมือง',
  state: 'จังหวัด',
  country: 'ประเทศ',
  zip: 'รหัสไปรษณีย์',
  holdCode: 'Hold Code',
  PayTerms: 'Pay Terms',
  qty: 'จำนวน',
  discPct: '% ส่วนลด',
  discAmount: 'ส่วนลดเงินสด',
  totalAmount: 'ราคารวม',
  ReceiptForm: 'Receipt Form',
  SIDSticker: 'SID STICKER',
  No: 'No.',
  itemNo: 'Item No.',
  itemDesc: 'Item Description',
  containerType: 'Container Type',
  orderItemID: 'Order Item ID',
  orderItemName: 'Order Item Name',
  testItemID: 'Test Item ID',
  testItemName: 'Test Item Name',
  pricing: 'Pricing',
  MessageStatusOpenDeleteOrderItem: 'Status must have Open can Delete Order Item',
  MessageStatusOpenAddOrderItem: 'Status must have Open can Add Order Item',
  active: 'Active',
  newCustomer: 'สร้างลูกค้า',
  customerInformation: 'ข้อมูลลูกค้า',
  copyPatient: 'คัดลอกข้อมูลคนไข้',
  Gender: 'เพศ',
  CollectionDate: 'วันที่เก็บสิ่งส่งตรวจ',
  SecondaryApprovedDate: 'วันที่อนุมัติผลตรวจ',
  AiProcessing: 'ประมวลผลด้วย AI',
  Age: 'อายุ',
  LabReport: 'รายงานผลทางห้องปฏิบัติการ',
  AIGeneratedLabReport: 'รายงานผลทางห้องปฏิบัติการโดย AI',
  LabResultReport: 'รายงานผลการตรวจทางห้องปฏิบัติการ',
  AiProcessingTitle: 'ส่งข้อมูลให้ AI เรียบร้อยแล้ว!',
  AiProcessingText: 'รายงานนี้ได้รับการส่งไปประมวลผลด้วย AI สำเร็จแล้ว'
}
